export default "__VITE_ASSET__M$RyF3PE__"